import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { LoaderState } from './loader.state';
import { LoaderStateModel } from './loader.state-model';

@Injectable()
export class LoaderSelectors {
  @Selector([LoaderState])
  static isLoading(state: LoaderStateModel): boolean {
    return state.counter > 0;
  }
}
